<div class="row ms-0 me-0 mt-2 mb-1">
    <div class="col-12 ps-1 pe-1">
        <h4 class="mb-1">Admin settings</h4>
        <p class="settings-subtitle">
            Add or remove vehicles from the <strong>{{ bitcGroupName }}</strong> group, individually or in bulk.
        </p>
    </div>
</div>
<hr>

<div class="row m-0 p-0 pb-2">
    <div class="col-12 ps-1 pe-1 d-flex justify-content-start">
        <button type="button" class="rb-btn rb-primary" (click)="checkNewVehicles()">
            <span class="rb-ic rb-ic-car-connected"></span>
            &nbsp; Check new vehicles
        </button>
    </div>
</div>

<div class="row ms-0 me-0 mt-1 mb-1">
    <div class="col-md-3 ps-1 pe-1 d-flex align-items-end">
        <rb-form-input class="rb-input search-input" placeholder="Search vehicles..." [(ngModel)]="searchQuery"
            (input)="applySearchAndSort()" />
    </div>
    <div class="col-md-9 ps-1 pe-1 d-flex justify-content-end align-items-end flex-wrap">
        <span class="selection-info me-2" *ngIf="selectedCount > 0">{{ selectedCount }} selected</span>
        <button type="button" class="rb-btn rb-primary me-2" (click)="addSelectedToGroup()"
            [disabled]="selectedNotInGroupCount === 0">
            <span class="rb-ic rb-ic-add"></span>
            &nbsp; Add selected to {{ bitcGroupName }}
        </button>
    </div>
</div>

<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>

<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">No vehicles found!</rb-callout>
</div>

<div class="row ms-0 me-0" *ngIf="!dataLoading && !errorMessage">
    <div class="col-12" *ngIf="displayVehicles.length > 0; else noVehicles">
        <table class="m-table" *rbTable="loader; fixedHeaderWidth: false; columns: 8" [rbSort]="sort"
            (rbSortChange)="onSortChange($event)">
            <thead>
                <tr>
                    <th class="checkbox-cell">
                        <rb-form-checkbox name="selectAll" [ngModel]="allSelected"
                            [disabled]="selectableVehicles.length === 0"
                            (ngModelChange)="toggleSelectAll($event)" [ngModelOptions]="{ standalone: true }">
                        </rb-form-checkbox>
                    </th>
                    <th rb-sort-header="name" [disableSortClear]="true">Asset Name</th>
                    <th rb-sort-header="batteryIdentifier" [disableSortClear]="true">Serial Number</th>
                    <th rb-sort-header="enrolled" [disableSortClear]="true">Subscribed</th>
                    <th rb-sort-header="vehicleBrand" [disableSortClear]="true">Vehicle Brand</th>
                    <th rb-sort-header="vehicleModel" [disableSortClear]="true">Vehicle Model</th>
                    <th>{{ bitcGroupName }} group</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let vehicle of displayVehicles; trackBy: trackByVehicleId"
                    [class.row-selected]="isSelected(vehicle)">
                    <td class="checkbox-cell">
                        <rb-form-checkbox [name]="'select-' + getVehicleId(vehicle)" [ngModel]="isSelected(vehicle)"
                            [disabled]="isInGroup(vehicle)"
                            (ngModelChange)="toggleSelection(vehicle, $event)"
                            [ngModelOptions]="{ standalone: true }">
                        </rb-form-checkbox>
                    </td>
                    <td>{{ vehicle.name ? vehicle.name : 'N/A' }}</td>
                    <td>{{ vehicle.batteryIdentifier ? vehicle.batteryIdentifier : 'N/A' }}</td>
                    <td>{{ vehicle.enrolled ? 'Yes' : 'No' }}</td>
                    <td>{{ vehicle.vehicleBrand ? vehicle.vehicleBrand : 'N/A' }}</td>
                    <td>{{ vehicle.vehicleModel ? vehicle.vehicleModel : 'N/A' }}</td>
                    <td>
                        <span *ngIf="isInGroup(vehicle); else notInGroup" class="status-icon-assigned"
                            [title]="bitcGroupName + ' - Assigned'">
                            <span class="rb-ic rb-ic-checkmark-frame"></span>
                        </span>
                        <ng-template #notInGroup>
                            <span class="status-icon-unassigned" [title]="bitcGroupName + ' - Not assigned'">
                                <span class="rb-ic rb-ic-abort-frame"></span>
                            </span>
                        </ng-template>
                    </td>
                    <td class="no-wrap-cell">
                        <button *ngIf="!isInGroup(vehicle)" type="button" class="rb-btn rb-primary rb-small"
                            [title]="'Add to ' + bitcGroupName" (click)="addToGroup([vehicle])">
                            Add to {{ bitcGroupName }}
                        </button>
                        <button *ngIf="isInGroup(vehicle)" type="button" class="rb-btn rb-secondary rb-small"
                            [title]="'Remove from ' + bitcGroupName" (click)="removeFromGroup([vehicle])">
                            Remove from {{ bitcGroupName }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</div>

<ng-template #noVehicles>
    <div class="col-12">
        <rb-callout type="info">No vehicles match the current search.</rb-callout>
    </div>
</ng-template>

